import { AdminAllowanceNames, adminPharmaciesInfo, getProfessionalMetaInfo, IAdminBookedPharmacistDetails, IAdminRequestedDetailsData, IAdminWorkshiftDetails } from '@pharmaplan/common';
import { FormikProps } from 'formik';
import { useEffect } from 'react';
import { useAppSelector } from '../../useAppSelector';

const { pharmacistHourlyRate: pharmacistHourlyEnum, pharmacyHourlyRate } = AdminAllowanceNames;

const useExpressBookingPromos = (formik: FormikProps<any>, details: IAdminWorkshiftDetails | IAdminBookedPharmacistDetails | IAdminRequestedDetailsData, isBooking: boolean, id?:string) => {
  const pharmaciesInfo = useAppSelector(adminPharmaciesInfo);
  const professionalMetaInfo = useAppSelector(getProfessionalMetaInfo);
  const { pharmacistHourlyRate } = (details as IAdminWorkshiftDetails) ?? {};

  const { promoHourlyRate, creditsLeft, pharmacyWeekDayHourlyRate, pharmacyWeekendHourlyRate } = pharmaciesInfo ?? {};
  const {
    creditsLeft: professionalCreditsLeft,
    promoHourlyRate: hourlyRateBonus = 0,
  } = professionalMetaInfo ?? {};

  const setPromo = () => {
    if (!isBooking) {
      formik.setFieldValue(pharmacistHourlyEnum, Number(id ? pharmacistHourlyRate : formik.values.pharmacistHourlyRate) + Number(hourlyRateBonus));
      formik.setFieldValue('hourlyRateBonus', hourlyRateBonus);
      formik.setFieldValue('professionalCreditsLeft', professionalCreditsLeft);
    }
  };

  useEffect(() => {
    if (professionalCreditsLeft) {
      setPromo();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [professionalCreditsLeft, hourlyRateBonus, pharmacistHourlyRate]);

  useEffect(() => {
    if (creditsLeft && !isBooking) {
      formik.setFieldValue(pharmacyHourlyRate, promoHourlyRate);
      formik.setFieldValue('creditsLeft', creditsLeft);
      formik.setFieldValue('promoHourlyRate', promoHourlyRate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditsLeft, promoHourlyRate]);

  useEffect(() => {
    formik.setFieldValue('pharmacyWeekDayHourlyRate', pharmacyWeekDayHourlyRate ?? 0);
    formik.setFieldValue('pharmacyWeekendHourlyRate', pharmacyWeekendHourlyRate ?? 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pharmaciesInfo?.pharmacyWeekDayHourlyRate, pharmaciesInfo?.pharmacyWeekendHourlyRate]);
};

export default useExpressBookingPromos;
